import { Component } from '@angular/core';

import { useDispatcher } from '../../../../../store.decorator';
import { EventCentreDialogService } from '../../event-centre-dialog.service';
import { selectCategory } from '../../state/select-category.action';

import { TranslationKeyMap } from './tab-bar.component.i18n';

@Component({
    selector: 'cmps-event-centre-tab-bar',
    templateUrl: './tab-bar.component.html',
    host: {
        class: 'cmps-event-centre-tab-bar',
    },
})
export class TabBarComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    constructor(/** @private */ readonly _service: EventCentreDialogService) {}

    /** @private */
    _onCategoryClick(categoryId: string): void {
        useDispatcher(this._service, selectCategory({ categoryId }));
    }
}
